import {
  AbsoluteCenter,
  Box,
  Flex,
  Icon,
  Image,
  Link,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import i18next from "i18next";
import { useEffect, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { NavLink, useLocation, useMatches, useParams } from "react-router-dom";
import { COMMON_WEB_PATH } from "../../../constant";
import { routeMappingV4 } from "./utils/routeMapping_v4";

const GameTypeSelector = ({ gameMainTypeFromProps, ltr } = {}) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const textColor = useColorModeValue("dark.100", "light.100");

  const isHandleAllGame = useSelector((state) => state.isHandleAllGame);
  const { gameType, gameList } = isHandleAllGame || {};

  const splideRef = useRef();

  const { gameMainType } = useParams();

  //顯示的遊戲類型
  const combileType = useMemo(() => {
    if (gameType) {
      // 定義要保留的遊戲類型
      const allowedTypes = [
        "SLOT",
        "LIVE",
        // "BINGO",
        "FH",
        // "SPORT",
        "TABLE",
        // "BLOCKCHAIN",
      ];
      //   // 過濾 gameType，只保留 allowedTypes 中的類型
      //   const filteredGameType = gameType.filter((type) =>
      //     allowedTypes.includes(type)
      //   );
      // 過濾 gameType，只保留 allowedTypes 中的類型，並按照 allowedTypes 的順序排序
      const filteredGameType = allowedTypes.filter((type) =>
        gameType.includes(type)
      );

      return ["LOBBY", ...filteredGameType];
    }
    return [];
  }, [gameType]);

  const gameSubTypeList = useMemo(() => {
    if (gameType) {
      const convertType = combileType.map((item) => {
        return routeMappingV4(item)?.link;
      });

      return [
        ...combileType.map((item, index) => {
          const { link } = routeMappingV4(item);
          const current_game_type = routeMappingV4(item)?.origin;

          const itemChildren = (
            <Link
              as={(props) => <NavLink {...props} />}
              to={`${link}`}
              _hover={{
                textDecoration: "none",
              }}
              display="flex"
              justifyContent={
                ltr ? "center" : index % 2 == 0 ? "flex-start" : "flex-end"
              }
              alignItems={
                ltr ? "center" : index % 2 == 0 ? "flex-start" : "flex-end"
              }
            >
              {(props) => {
                const { isActive } = props;
                return (
                  <Flex
                    role="group"
                    direction="column"
                    alignItems={
                      ltr
                        ? "center"
                        : index % 2 == 0
                        ? "flex-start"
                        : "flex-end"
                    }
                    position="relative"
                    height={{
                      base: "85px",
                      md: "120px",
                      lg: "145px",
                    }} // 固定容器高度
                    // w={item === "LIVE" ? "80px" : "80px"} // LIVE類型特別加寬
                    w={{
                      base: "85px",
                      md: "120px",
                      lg: "145px",
                    }}
                    justifyContent="center"
                    transition="all 0.3s"
                    p="1px"
                    gap="1px"
                    color="black"
                  >
                    <Box
                      position="relative"
                      // width={item === "LIVE" ? "80px" : "71px"} // 根據圖片原始寬度設定
                      w={{
                        base: "80px",
                        md: "110px",
                        lg: "140px",
                      }}
                      height={{
                        base: "85px",
                        md: "110px",
                        lg: "140px",
                      }} // 根據圖片原始高度設定
                    >
                      <Image
                        src={`${COMMON_WEB_PATH}/now888/gameType${
                          i18next.language == "tw" ? "" : `/${i18next.language}`
                        }/M_${current_game_type?.toUpperCase()}${
                          isActive ? "_active_" : "_"
                        }.png`}
                        position="absolute"
                        top="50%"
                        left="50%"
                        transform="translate(-50%, -50%)" // 確保圖片置中
                        width="100%"
                        height="100%"
                        objectFit="cover" // 確保圖片完整顯示
                        transition="0.3s"
                        _groupHover={{
                          src: `${COMMON_WEB_PATH}/5285/gameType${
                            i18next.language == "tw"
                              ? ""
                              : `/${i18next.language}`
                          }/M_${current_game_type?.toUpperCase()}_active_2.png?11`,
                        }}
                      />
                    </Box>
                  </Flex>
                );
              }}
            </Link>
          );
          return ltr ? (
            <SplideSlide key={index}>{itemChildren}</SplideSlide>
          ) : (
            itemChildren
          );
        }),
      ];
    }
  }, [gameType, i18next.language, gameList, combileType, textColor, ltr]);

  const findCurrentGameTypeIndex = useMemo(() => {
    const mainType = gameMainTypeFromProps || gameMainType;

    const processGameType = gameType?.map((item) => {
      const textMapping = routeMappingV4(item);

      return textMapping?.link.replace("/", "");
    });

    return processGameType?.indexOf(mainType);
  }, [gameType, gameMainType, gameMainTypeFromProps]);

  useEffect(() => {
    if (splideRef.current) {
      const mainType = gameMainTypeFromProps || gameMainType;
      const splide = splideRef.current.splide;
      const processGameType = gameType?.map((item) => {
        const textMapping = routeMappingV4(item);
        return textMapping?.link.replace("/", "");
      });
      splide.go(processGameType?.indexOf(mainType));
    }
  }, [gameType, gameMainType, gameMainTypeFromProps]);

  return (
    <Box maxW="100dvw" position="relative">
      <Box
        display={ltr ? "none" : "block"}
        position="absolute"
        left="-6px"
        top="-26px"
        w="100%"
        h="300px"
        bgSize="100% 100%"
        bgImage={`${COMMON_WEB_PATH}/now888/gameType/game_type_ribbon.png`}
      ></Box>
      <Box pt="3px">
        {ltr ? (
          <Splide
            ref={splideRef}
            options={{
              start: findCurrentGameTypeIndex,
              pagination: false,
              arrows: false,
              drag: "free",
              // perPage: 5,
              // perMove: 1,
              gap: "0px",
              lazyLoad: "nearby",
              direction: ltr ? "ltr" : "ttb",
              perPage: null,
              // fixedWidth: `${100 / combileType?.length}%`,
              dragMinThreshold: {
                mouse: 0,
                touch: 10,
              },
              fixedHeight: ltr ? null : "95px",
              height: ltr ? null : "calc(100% - 70px)",
              breakpoints: {
                mediaQuery: "min",
                550: {
                  fixedHeight: "85px",
                  height: ltr ? null : "calc(100% - 70px)",
                  fixedWidth: ltr ? "85px" : "100px",
                },
                1025: {
                  fixedHeight: "120px",
                  height: "400px",
                  fixedWidth: ltr ? "110px" : "100px",
                },
                5000: {
                  fixedHeight: "140px",
                  height: "400px",
                  fixedWidth: ltr ? "140px" : "100px",
                },
              },
            }}
          >
            {gameSubTypeList}
          </Splide>
        ) : (
          <Box
            w={{
              base: "100px",
              md: "125px",
              lg: "155px",
            }}
          >
            {gameSubTypeList}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default GameTypeSelector;
